export class GeneralInfo {
    public TaxPayerType: number;
    public VKNTCKN: string
    public CompanyName: string
    public FirstName: string
    public MiddleName:string;
    public LastName:string;

    public CommercialTitle:string;
    
    public BirthYear:string;
}
